<template>
  <div id="app" class="app">
  	 <nav class="mainnavigation">
	    	<router-link to="/"></router-link> 
	    	<router-link to="/aufnahme"></router-link> 
	    	<router-link to="/app"></router-link> 
	    	<router-link to="/spenden"></router-link>  
	   </nav>
 
	   <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
 
<script>
export default {
  name: 'app',
   data () {
    return {
     
    }
  },
  computed:{
 
  },

  methods:{
 
  },
 
}
</script>
<style lang="scss">
   	@import './assets/scss/app.scss'
</style>


// WEBPACK FOOTER //
// src/App.vue